// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleMeta_root__277QJ","ideasRoot":"ArticleMeta_ideasRoot__1nBo4"};